// extracted by mini-css-extract-plugin
export default {"clickable":"Icon_clickable__ij9dC"};